import { render, staticRenderFns } from "./CompaniesConnections.vue?vue&type=template&id=0f492b66&scoped=true"
import script from "./CompaniesConnections.vue?vue&type=script&lang=js"
export * from "./CompaniesConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f492b66",
  null
  
)

export default component.exports